import { render, staticRenderFns } from "./off-site-mailbox.vue?vue&type=template&id=b1b2e5f8&scoped=true&"
import script from "./off-site-mailbox.vue?vue&type=script&lang=js&"
export * from "./off-site-mailbox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1b2e5f8",
  null
  
)

export default component.exports